export default __webpack_public_path__ + "static/media/samsungpay.75def290.png";